import React, { createElement, Fragment } from 'react';
import { Mask } from '@ifeng-fe/lowcode_tool/src/components/Mask'
import { useChip, TYPE_Chip } from '@ifeng-fe/lowcode_tool/src/hooks/useChip'
import { formatChip } from '@ifeng-fe/lowcode_tool/src/method/chip'
import Chip from 'Chip';

export interface HtmlProps {
    nodeId?: string
    htmlChip: TYPE_Chip;
}

const Html: React.FC<HtmlProps> = (props) => {
    const { nodeId, htmlChip } = props;

    const chipData = useChip(htmlChip);
    const chipComponentData = formatChip(htmlChip)

    return (
        <Fragment>
            {
                chipData.length > 0
                    ? (
                        htmlChip.id
                            ?
                                <Chip {...chipComponentData}>
                                    <div id={nodeId} dangerouslySetInnerHTML={{ __html: chipData }} />
                                </Chip>
                            : <div id={nodeId} dangerouslySetInnerHTML={{ __html: chipData }} />

            ) : (
                <div id={nodeId} style={{ width: '100%', height: '100px', position: 'relative' }}>
                    <Mask visible={chipData.length < 1} zIndex={3}>默认 HTML 内容</Mask>
                </div>
            )}
        </Fragment>
    );
};

Html.displayName = '纯代码';

export default Html;
